import React, { useState, useEffect } from "react";
import Moment from "react-moment";

function ReportsList() {
  let AccessToken = localStorage.getItem("AccessToken");
  let NodeServerHost = process.env.REACT_APP_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");

  const [hasError, setHasError] = useState(false);

  const requestOptions = {
    method: "GET",
    headers: {
      OrganizationId: orgId,
      CareCode: CareCode,
      OperatingId: OperatingId,
      Subject: "_include=DiagnosticReport:subject",
      Authorization: "Bearer " + AccessToken,
      "Content-Type": "application/json",
    },
  };

  const [reportList, setReportList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetch(NodeServerHost + `/Report`, requestOptions)
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        setIsLoading(false);
        setReportList(responseData);
      })
      .catch((err) => setHasError(true));
  }, []);

  console.log(reportList);

  return (
    <div>
      <h4 className="p-3 mb-0 float-start"><small>Reports</small></h4>
      <div className="col col-lg-12 pe-3 ps-3">
        <table className="table">
          <thead>
            <tr className="table-active">
              <th>Patient Name</th>
              <th>Report Name</th>
              <th>File Type</th>
              <th>Category</th>
              <th>Report Date</th>
              <th>Upload Date</th>
              <th>Status</th>
              <th>Actions </th>
            </tr>
          </thead>
          {isLoading === true && (
            <tbody>
              <tr>
                <td colSpan="8">
                  <div className="spinner-border" role="status"></div>Loading...
                </td>
              </tr>
            </tbody>
          )}
          {isLoading === false && (
            <tbody>
              {reportList === "No records found"
              ? <tr>
                  <td colSpan="8">
                    {reportList}
                  </td>
                </tr>
              : reportList.map((diagnosticreport) => {
                  if (diagnosticreport.resourceType === "DiagnosticReport") {
                    const lastUpdatedTime = diagnosticreport.meta.lastUpdated.split(".");
                    
                    const imagingstudyAccession = diagnosticreport.identifier.map((id) => {
                      if (id.type?.text === "Accession ID") {
                        return id.value;
                      }
                    })
                    const accessionNumber = imagingstudyAccession.filter((element) => {
                      return element !== undefined;
                    });

                    //console.log(accessionNumber);
                    const patientInfo = reportList?.map((patient) => {
                      if (patient.resourceType === "Patient") {
                        const mrn = patient.identifier.map((id) => {
                          console.log(id.type.text);
                          if (id.type.coding[0].code === "MR") {
                            return id.value;
                          }
                        });
                        //console.log(mrn[0])
                        return {
                          patientId: patient.id,
                          patientName:
                            patient.name[0].given[0] +
                            " " +
                            patient.name[0].family,
                          patientDOB: patient.birthDate,
                          patientGender: patient.gender,
                          patientMRN: mrn[0],
                        };
                      }
                    });

                    const patientData = patientInfo.filter((element) => {
                      return element !== undefined;
                    });
                    console.log(diagnosticreport.effectivePeriod)
                    return (
                      <tr>
                        <td className="hyperlinkView">
                          <span>
                            <strong>{patientData[0].patientName}</strong>
                          </span>
                          <br></br>
                          <span className="text-secondary">
                            {patientData[0].patientGender === ""
                              ? ""
                              : patientData[0].patientGender === "male"
                              ? "( M )"
                              : patientData[0].patientGender === "female"
                              ? "( F )"
                              : patientData[0].patientGender === "other"
                              ? "( O )"
                              : ""}{" "}
                            DOB{" "}
                            <Moment format="MM/DD/YYYY">
                              {patientData[0].patientDOB}
                            </Moment>
                          </span>
                          <br></br>
                          <span className="text-secondary">
                            MRN {patientData[0].patientMRN}
                          </span>
                        </td>
                        <td className="hyperlinkView">
                          <strong>{diagnosticreport.code.coding[0].display}</strong>
                        </td>
                        <td>Report</td>
                        <td>{diagnosticreport.category[0].coding[0].code}</td>
                        <td>
                          <Moment format="MM/DD/YYYY">
                            {diagnosticreport.effectivePeriod?.start}
                          </Moment>
                          <br></br>
                          <Moment
                            className="text-secondary"
                            parse="YYYY-MM-DD HH:mm"
                            format="hh:mm a"
                          >
                            {diagnosticreport.effectivePeriod?.start}
                          </Moment>
                        </td>
                        <td>
                          <Moment format="MM/DD/YYYY">
                            {diagnosticreport.meta.lastUpdated}
                          </Moment>
                          <br></br>
                          <Moment className="text-secondary" format="hh:mm a">
                            {lastUpdatedTime[0]}
                          </Moment>
                        </td>
                        <td>{diagnosticreport.status}</td>
                        <td>
                          <div className="btn-group actionBtn float-start mt-3 me-4">
                            <a href="javacript:void(0)" className="btn dropdown-toggle icon-action no-droparrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action vieweye-icn"></i>
                              <span>View</span>
                            </a>
                          </div>
                          <div className="btn-group actionBtn float-start mt-3 me-4">
                            <a href="javacript:void(0)" className="btn dropdown-toggle icon-action no-droparrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action reports-icn"></i>
                              <span>Reports</span>
                            </a>
                          </div>
                          <div className="btn-group actionBtn float-start mt-3 me-4">
                            <a href="javacript:void(0)" className="btn dropdown-toggle icon-action no-droparrow" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <i className="icon-action share-icn"></i>
                              <span>Share</span>
                            </a>
                          </div>
                        </td>
                      </tr>
                    );
                  }
                })}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
}

export default ReportsList;
